import { Flex, Stack, Text, Avatar } from '@mantine/core';
import { Check } from 'lucide-react';
import { ReactNode } from 'react';

export interface SelectOptionWithIconProps {
  option: {
    value: string;
    label: string;
    subtitle?: string;
    icon?: string | ReactNode;
  };
  selected?: boolean;
}

export const SelectOptionWithIcon = ({
  option,
  selected,
}: SelectOptionWithIconProps) => (
  <Flex
    align='center'
    gap='sm'
    style={{
      minWidth: 0,
      width: '100%',
    }}
  >
    <Avatar
      src={typeof option.icon === 'string' ? option.icon : undefined}
      alt={option.label}
      size={32}
      radius='sm'
      color='gray.6'
    >
      {typeof option.icon !== 'string' ? option.icon : null}
    </Avatar>
    <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
      <Text
        size='sm'
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {option.label}
      </Text>
      {option.subtitle && (
        <Text
          size='xs'
          c='dimmed'
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {option.subtitle}
        </Text>
      )}
    </Stack>
    <Flex justify='flex-end' style={{ flexShrink: 0 }}>
      {selected && <Check size={20} strokeWidth={3} color='green' />}
    </Flex>
  </Flex>
);
